export default {
  data() {
    return {
      comparisonOperators: [
        {
          text: 'Igual',
          value: '=',
        },
        {
          text: 'Diferente de',
          value: '!=',
        },
        {
          text: 'Mayor que',
          value: '>',
        },
        {
          text: 'Menor que',
          value: '<',
        },
        {
          text: 'Mayor o igual que',
          value: '>=',
        },
        {
          text: 'Menor o igual que',
          value: '<=',
        },
      ],
    };
  },
  methods: {
    getOperatorName(value) {
      const op = this.comparisonOperators.find(item => item.value === value);
      return op ? op.text : value;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/comparisonOperators.js